import React, {PureComponent} from "react"
import styled from "styled-components"

import {StatementItem} from "@irati/types"
import withBranding, {WithBranding} from "@irati/brand/withBranding"
import id from "@irati/utils/id"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import StatusType from "@irati/wallet/types/enums/Status"
import Card from "@irati/ui/src/Layout/Card"
import authentication from "@irati/auth"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"

import PrimaryDetails from "../../../PrimaryDetails"

const StyledCard = styled(Card)`
  margin-bottom: 20px;
  box-shadow: 0 4px 11px 0 rgba(82, 97, 115, 0.18);
`

interface Props extends InjectIntl, WithBranding {
  statementItem: StatementItem
  className?: string
  isBankTransfer?: boolean
}

// TODO show invoice ref number if Bank transfer, need a design

class TopUp extends PureComponent<Props> {
  static defaultProps = {
    isBankTransfer: false
  }
  getSubTitle = () => {
    const {formatMessage, isBankTransfer} = this.props
    return isBankTransfer
      ? formatMessage({id: "wallet.reward.topup.bankTransfer"})
      : formatMessage({id: "wallet.reward.topup.cardPayment"})
  }
  render() {
    const {statementItem, branding} = this.props
    const tenant = authentication.userTenant()
    const primaryDetails = {
      image: branding.businessLogoUrl || perkboxLogo,
      title: tenant.public_name,
      subTitle: this.getSubTitle(),
      amount: statementItem.transfer.amount,
      currency: statementItem.transfer.currency,
      status: StatusType.CLEARED
    }

    const idNamespace = id("top-up", this.props)

    return (
      <StyledCard medium noBorder>
        <PrimaryDetails imgHeightAuto id={idNamespace} data={primaryDetails} />
      </StyledCard>
    )
  }
}

export default injectIntl(withBranding(TopUp))
